import { render, staticRenderFns } from "./drawerAction.vue?vue&type=template&id=edd13c32"
import script from "./drawerAction.vue?vue&type=script&lang=js"
export * from "./drawerAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports